import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=36f152b1"
import script from "./viewInvoice.vue?vue&type=script&lang=js"
export * from "./viewInvoice.vue?vue&type=script&lang=js"
import style0 from "./viewInvoice.vue?vue&type=style&index=0&id=36f152b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports